import NoticeboardEntry from '@model/NoticeboardEntry'
import { AxiosRepository } from '@pinia-orm/axios'

export default class NoticeboardEntriesRepo extends AxiosRepository<NoticeboardEntry> {
    use = NoticeboardEntry

    update(event) {
        this.flush()

        return this.api().get('/events/' + event.ctlId + '/noticeboard', {
            dataTransformer: ({ data }) => {
                return data.map((line) => ({
                    id: parseInt(line.id),
                    eventId: event.id,
                    desc: Object.hasOwn(line, 'desc') ? String(line.desc) : undefined,
                    url: Object.hasOwn(line, 'url') ? String(line.url) : undefined,
                    when: new Date(line.when),
                    files: Object.hasOwn(line, 'files')
                        ? line.files.map((file) => ({
                            id: parseInt(file.id),
                            name: String(file.name),
                            size: parseInt(file.size),
                            desc: Object.hasOwn(file, 'desc') ? String(file.desc) : undefined,
                            title: Object.hasOwn(file, 'title') ? String(file.title) : undefined,
                        }))
                        : [],
                }))
            },
        })
    }
}
